/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/filters%2FcreateRangeFilter%2Fvalidate%2FvalidateRangeFilterExpression.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'Неправильный формат': {
        ru: 'Неправильный формат',
        en: 'Invalid format',
        'en-IE': 'Incorrect format',
        tr: 'Hatalı format',
        'zh-Hans': '无效格式',
    },
    'Повторяющиеся условия': {
        ru: 'Повторяющиеся условия',
        en: 'Duplicate conditions',
        'en-IE': 'Recurring conditions',
        tr: 'Tekrarlayan koşullar',
        'zh-Hans': '重复条件',
    },
    'Указано несколько противоречащих условий': {
        ru: 'Указано несколько противоречащих условий',
        en: 'Multiple conflicting conditions specified',
        'en-IE': 'Several contradictory conditions are specified',
        tr: 'Birden fazla çelişkili koşul belirtildi',
        'zh-Hans': '指定了多个互相冲突的条件',
    },
    'Указано несколько условий одинакого типа': {
        ru: 'Указано несколько условий одинакого типа',
        en: 'Multiple same type conditions specified',
        'en-IE': 'Several conditions of the same type are specified',
        tr: 'Aynı türden birden fazla koşul belirtildi',
        'zh-Hans': '指定了多个相同类型的条件',
    },
    'Указано несколько условий равенства': {
        ru: 'Указано несколько условий равенства',
        en: 'Multiple equality conditions specified',
        'en-IE': 'Several equality conditions are specified',
        tr: 'Birden fazla eşitlik koşulu belirtildi',
        'zh-Hans': '指定了多个相等条件',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
